// Consommation/ConsommationChangementCompteur.jsx
import React from "react";
import AjouterConsommationChangementCompteur from "../consommation/AjouterConsommationChangementCompteur";
import { Box } from "@mui/material";
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";

const ConsommationChangementCompteur = () => {
  return (
    <Box m="1rem 2rem">
      <FlexBetween sx={{ mt: -2, mb: 1 }}>
        <Header title="Ajouter Consommation pour un changement de Compteur" />
      </FlexBetween>
      <AjouterConsommationChangementCompteur />
    </Box>
  );
};

export default ConsommationChangementCompteur;